var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalTraining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.7367 112.357C94.7543 115.024 84.3131 120.472 90.6724 127.287C93.7789 130.617 97.2395 132.998 101.589 132.998H114H126.411C130.761 132.998 134.221 130.617 137.328 127.287C143.687 120.472 133.246 115.024 129.263 112.357C119.925 106.101 108.075 106.101 98.7367 112.357Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7367 112.357C94.7543 115.024 84.3131 120.472 90.6724 127.287C93.7789 130.617 97.2395 132.998 101.589 132.998H114H126.411C130.761 132.998 134.221 130.617 137.328 127.287C143.687 120.472 133.246 115.024 129.263 112.357C119.925 106.101 108.075 106.101 98.7367 112.357Z",
    stroke: "url(#paint0_linear_16725_941)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.667 79.1654C126.667 86.1612 120.996 91.8321 114 91.8321C107.004 91.8321 101.333 86.1612 101.333 79.1654C101.333 72.1696 107.004 66.4988 114 66.4988C120.996 66.4988 126.667 72.1696 126.667 79.1654Z",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.667 79.1654C126.667 86.1612 120.996 91.8321 114 91.8321C107.004 91.8321 101.333 86.1612 101.333 79.1654C101.333 72.1696 107.004 66.4988 114 66.4988C120.996 66.4988 126.667 72.1696 126.667 79.1654Z",
    stroke: "url(#paint1_linear_16725_941)",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3335 37.9985H95.0002M63.3335 18.9985H114",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3335 37.9985H95.0002M63.3335 18.9985H114",
    stroke: "url(#paint2_linear_16725_941)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3332 60.165V88.6653C44.3332 94.6364 44.3332 97.6219 42.4782 99.4769C40.6232 101.332 37.6376 101.332 31.6665 101.332H25.3332C19.362 101.332 16.3765 101.332 14.5215 99.4769C12.6665 97.6219 12.6665 94.6364 12.6665 88.6653V72.832C12.6665 66.8609 12.6665 63.8754 14.5215 62.02C16.3765 60.165 19.362 60.165 25.3332 60.165H44.3332ZM44.3332 60.165H75.9998",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3332 60.165V88.6653C44.3332 94.6364 44.3332 97.6219 42.4782 99.4769C40.6232 101.332 37.6376 101.332 31.6665 101.332H25.3332C19.362 101.332 16.3765 101.332 14.5215 99.4769C12.6665 97.6219 12.6665 94.6364 12.6665 88.6653V72.832C12.6665 66.8609 12.6665 63.8754 14.5215 62.02C16.3765 60.165 19.362 60.165 25.3332 60.165H44.3332ZM44.3332 60.165H75.9998",
    stroke: "url(#paint3_linear_16725_941)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1668 31.6652C41.1668 38.6608 35.4958 44.3319 28.5002 44.3319C21.5046 44.3319 15.8335 38.6608 15.8335 31.6652C15.8335 24.6696 21.5046 18.9985 28.5002 18.9985C35.4958 18.9985 41.1668 24.6696 41.1668 31.6652Z",
    stroke: "white",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1668 31.6652C41.1668 38.6608 35.4958 44.3319 28.5002 44.3319C21.5046 44.3319 15.8335 38.6608 15.8335 31.6652C15.8335 24.6696 21.5046 18.9985 28.5002 18.9985C35.4958 18.9985 41.1668 24.6696 41.1668 31.6652Z",
    stroke: "url(#paint4_linear_16725_941)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_941",
    x1: 88.6665,
    y1: 107.665,
    x2: 137.817,
    y2: 135.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_941",
    x1: 101.333,
    y1: 66.4988,
    x2: 131.44,
    y2: 75.0729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_941",
    x1: 63.3335,
    y1: 18.9985,
    x2: 104.618,
    y2: 50.3522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_941",
    x1: 12.6665,
    y1: 60.165,
    x2: 80.932,
    y2: 90.0751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16725_941",
    x1: 15.8335,
    y1: 18.9985,
    x2: 45.9398,
    y2: 27.5726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalTraining);
export default __webpack_public_path__ + "static/media/Personal-training.bc8c3916ad82237ddf2d0ff2b524bb01.svg";
export { ForwardRef as ReactComponent };